export const COLORS = {
    primary: '#010624',
    secondary: '#006494',
    success: '#28a745',
    danger: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    light: '#00A6FB',
    dark: '#051923',
    white: '#fff',
    green: '#4ab749',
    greenHover: '#4ab740',
    greenDisabled: '#4ab74f',
    navText: '#B2B8CD',
    iconColor: '#626876',
};

export const BACKGROUND = {
    primary: COLORS.primary,
    secondary: COLORS.primary,
    light: COLORS.light,
    dark: COLORS.dark,
}

export const COLOR = {
    primary: COLORS.navText,
    iconColor: COLORS.iconColor,
}

export const VIDEOS = {
    height: `${1920 / 3}`,
    width: `${1080 / 3}`
}